import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts, PagedResponse, QueryParams } from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";
export class AwardingOrgService extends BaseRemoteService {
  public async search(params: QueryParams, opts?: Opts): Promise<PagedResponse<Model>> {
    const mappedParams = { ...params, search: params.search || params.query };
    const url = `${this.apiRoot}/organisations/${paramsToSearchString(mappedParams)}`;
    const response = await super.getRequest<PagedResponse<Model>>(url, opts);
    const mappedData = response.data.map((item) => ({
      id: item.recognitionNumber,
      label: item.name,
    }));
    return {
      ...response,
      data: mappedData
    };
  }

  public async get(itemId: string, opts: Opts): Promise<Model> {
    const url = `${this.apiRoot}/organisations/${itemId}`;

    try {
      const data = await super.getRequest<Model>(url, opts);
      return {
        id: data.recognitionNumber,
        label: data.name,
      };
    } catch(e) {
      return {
        id: +itemId,
        label: "Error on" + itemId,
      };
    }
  }
}